module.exports = __webpack_public_path__ + "static/media/problem.b78122a4.svg";